import styled from 'styled-components';
import { Text } from 'components/Base/Typography';
import { Input } from 'components/Base/Input';
import Button from 'components/Base/Button/Button';

export const StyledAssigneeButton = styled(Button)`
  transition: all 0.2s ease;
  height: 40px;
  border-radius: 4px;
  padding: 0;
  color: #414042;
  background-color: transparent !important;

  &:hover {
    background-color: transparent !important;
  }
  &:focus,
  &:focus-within,
  &:active,
  &:focus-visible {
    border-color: transparent !important;
    box-shadow: none !important;
    outline: none !important;
    color: #414042 !important;
  }
  .ant-wave {
    display: none !important;
  }
`;

export const StyledSearchInput = styled(Input)`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const StyledPersonItem = styled(Text)`
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  max-width: 180px;
  width: 180px;

  &:hover {
    background-color: #e9f7f7;
  }
`;
